import { logger } from 'packages';
import { nullifyUndefinedProperties } from 'tradera-utils/object';

/**
 *
 * @param {object} initData
 * @param {object} [initData.featureSwitches]
 * @param {object} [initData.startPageResponse]
 * @param {object} [initData.trendingBrands]
 * @param {object} [initData.trendingSearches]
 * @returns {{isFetching: boolean, hasResults: boolean, config: object, trendingBrands: object, trendingSearches: object}}
 */
export default (initData = {}) => {
    const {
        startPageResponse,
        trendingBrands = { items: [], status: 'NOT_FETCHED' },
        trendingSearches = { items: [], status: 'NOT_FETCHED' },
        wishList = { itemIds: [], status: 'NOT_FETCHED' },
        favouriteSellers = {
            sellers: [],
            sellerSuggestions: [],
            items: [],
            totalItems: 0,
            status: 'NOT_FETCHED'
        }
    } = initData;
    let config;
    if (startPageResponse?.config) {
        try {
            config = JSON.parse(startPageResponse.config);
        } catch (error) {
            logger(error);
        }
    }
    return nullifyUndefinedProperties({
        status: config ? 'HAS_DATA' : 'NOT_FETCHED',
        config,
        trendingBrands,
        trendingSearches,
        wishList,
        favouriteSellers
    });
};
